import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { H2, Section } from '../ui/Section';
import { CtaButton } from '../ui/CtaButton';
import { guaranteeItems } from '../../data/content';
export function GuaranteeSection() {
  return <Section tone="white" narrow data-id="element-129" data-mp="1k9rfwbd82vl1">
      <div className="flex flex-col items-center text-center" data-id="element-130" data-mp="1fd13by0mmi4d">
        <div className="flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-gold bg-navy text-white" data-id="element-131" data-mp="1faom5n2p0bsd">
          <ShieldCheckIcon className="h-9 w-9 text-gold" aria-hidden="true" data-id="element-132" data-mp="15euyp8nfqxvt" />
          <span className="mt-1 font-display text-sm font-black uppercase leading-none" data-id="element-133" data-mp="15gxxoi6kg1co">7 days</span>
        </div>
        <p className="mt-6 font-display text-base font-bold uppercase text-accent-strong" data-id="element-134" data-mp="we6kody1kxix">My 7-day guarantee</p>
        <H2 className="mt-2" data-id="element-135" data-mp="2vrkgwdi3a9zu">Explore Dental Implant Clinical Roadmap™ With Confidence.</H2>
      </div>

      <div className="mt-8 space-y-4 text-lg leading-relaxed text-ink/80" data-id="element-136" data-mp="2qremwqockbel">
        <p data-id="element-137" data-mp="1g4truyexowoi">I want you to have the opportunity to review the materials and decide whether this educational system is useful for your professional learning.</p>
        <p data-id="element-138" data-mp="1l5hs8ap1ypve">That’s why the offer includes a 7-day refund period. During those seven days, you can:</p>
      </div>

      <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-139" data-mp="175zwtch94ed2">
        {guaranteeItems.map(item => <li key={item} className="flex gap-2.5 text-base font-medium leading-snug" data-id="element-140" data-mp="1c3i8hamnl7or">
            <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-141" data-mp="1ztcmhvipl2al" />
            {item}
          </li>)}
      </ul>

      <p className="mt-8 rounded-2xl bg-paper p-5 text-base leading-relaxed" data-id="element-142" data-mp="1q3j9qr6tyh4r">
        If you decide the collection isn’t right for you, contact our support team within seven days of purchase to request a refund.
      </p>

      <div className="mt-10" data-id="element-143" data-mp="2iqnhv517zbkr">
        <CtaButton label="Get instant access with the 7-day guarantee" note="Zero risk · $27 USD one-time" data-id="element-144" data-mp="2iqdor8kvooau" />
      </div>
    </Section>;
}